import { supabase } from "../lib/supabase";
import type {
  CommissionLevel,
  CreateCommissionLevelData,
  UpdateCommissionLevelData,
} from "../types/commission-level";

export const TABLE_NAME = "commission_levels";

/**
 * Fetch all commission levels ordered by level number
 */
export async function getCommissionLevels(): Promise<CommissionLevel[]> {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select("*")
    .order("level_number", { ascending: true });

  if (error) {
    console.error("Error fetching commission levels:", error);
    throw error;
  }
  return data || [];
}

/**
 * Create a new commission level
 */
export async function createCommissionLevel(
  data: CreateCommissionLevelData
): Promise<CommissionLevel> {
  const { data: newLevel, error } = await supabase
    .from(TABLE_NAME)
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error("Error creating commission level:", error);
    throw error;
  }
  return newLevel;
}

/**
 * Update an existing commission level
 */
export async function updateCommissionLevel(
  id: number,
  updates: UpdateCommissionLevelData
): Promise<CommissionLevel> {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(updates)
    .eq("id", id)
    .select()
    .single();

  if (error) {
    console.error("Error updating commission level:", error);
    throw error;
  }
  return data;
}

/**
 * Delete a commission level
 */
export async function deleteCommissionLevel(id: number): Promise<void> {
  const { error } = await supabase.from(TABLE_NAME).delete().eq("id", id);

  if (error) {
    console.error("Error deleting commission level:", error);
    throw error;
  }
}
